import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { F_STR } from 'assets/FormatNumbers'

type TableState = {
  isChecked: boolean
  message: string
  page: number
  pageDetail: number
  perPage: number
  perPageDetail: number
}

const initialState: TableState = {
  isChecked: false,
  message: F_STR,
  page: 0,
  perPage: 50,
  pageDetail: 0,
  perPageDetail: 50,
}
export const TableSlice = createSlice({
  name: 'Table',
  initialState: initialState,
  reducers: {
    formatPageDetail: (state) => {
      state.pageDetail = initialState.pageDetail
    },
    changePageDetail: (state, action: PayloadAction<number>) => {
      state.pageDetail = action.payload
    },
    changePerPageDetail: (state, action: PayloadAction<number>) => {
      state.perPageDetail = action.payload
      state.pageDetail = initialState.pageDetail
    },
    checkAll: (state, action: PayloadAction<boolean>) => {
      state.isChecked = action.payload
    },
    formatPage: (state) => {
      state.perPage = initialState.perPage
      state.page = initialState.page
    },
    changePage: (state, action: PayloadAction<number>) => {
      state.page = action.payload
    },
    changePerPage: (state, action: PayloadAction<number>) => {
      state.perPage = action.payload
      state.page = initialState.page
    },
    changeMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload
    },
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof TableState = key as keyof TableState
        if (tempKey !== 'perPageDetail') (state as any)[tempKey] = initialState[tempKey]
      }
    },
    formatAll: (state) => {
      for (const key in state) {
        const tempKey: keyof TableState = key as keyof TableState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const { formatPageDetail, changePageDetail, changePerPageDetail, checkAll, formatPage, changePage, changePerPage, changeMessage, format, formatAll } = TableSlice.actions
export default TableSlice.reducer
